<template>
    <div class="button-group-two">
        <label :for="name"> {{ labelPartOne }} <span style="white-space:nowrap;">{{ labelPartTwo }} <span id="tooltip-id" ref="tooltip-id" @mouseover="showTooltip" @mouseleave="hideTooltip" v-show="hasTooltip" class="label-tooltip rounded-circle">?<span v-show="activeTooltip" class="calc-tooltip">{{ tooltipText }}<div class="arrow-down"></div></span></span></span></label>
        <div :id="name" class="btn-group" role="group" aria-label="Basic example">
            <button v-on:click="activeChoiceOne" id="button-one" v-bind:class="{'active-button': isActiveOne}" type="button" class="btn">{{ buttonOneText }}</button>
            <button v-on:click="activeChoiceTwo" id="button-two" v-bind:class="{'active-button': isActiveTwo}" type="button" class="btn">{{ buttonTwoText }}</button>
        </div>
    </div>
</template>

<script>
    export default {
        name: "button-group-two",
        data () {
            return {
                activeTooltip: false
            }
        },
        props: {
            name: String,
            label: String,
            buttonOneText: String,
            buttonTwoText: String,
            currentValue: String,
            hasTooltip: Boolean
        },
        methods: {
            activeChoiceOne: function () {
                this.$emit('calcOne', this.buttonOneText);
            },
            activeChoiceTwo: function () {
                this.$emit('calcTwo', this.buttonTwoText);
            },
            showTooltip: function () {
                this.activeTooltip = true;
            },
            hideTooltip: function () {
                this.activeTooltip = false;
            }
        },
        computed: {
            labelPartOne: function () {
                return this.label.substring(0, this.label.lastIndexOf(" ") + 1);
            },
            labelPartTwo: function () {
                return this.label.substring(this.label.lastIndexOf(" ") + 1);
            },
            isActiveOne: function () {
                return this.currentValue === this.buttonOneText;
            },
            isActiveTwo: function () {
                return this.currentValue === this.buttonTwoText;
            },
            tooltipText: function () {
                var helpText = "";

                switch (this.name) {
                    case 'Deposit':
                        helpText = "The deposit can be entered as a $ amount or a % of the purchase price. " +
                            "It can be paid using 'cash' or borrowed 'equity' from another property. " +
                            "If 'equity' is selected, the calculator will apply an interest charge to " +
                            "all purchase costs in the calculation";
                        break;
                    case 'Loan-Type':
                        helpText = "With 'Principal & Interest', the loan amount is repaid over " +
                            "the selected loan term. ‘Interest Only’ loans don’t pay down any debt however " +
                            "will result in a better yearly cashflow position";
                        break;
                }

                return helpText;

            }
        },
        mounted() {

            let $vm = this;
            var tooltip = this.$refs['tooltip-id'];
            tooltip.addEventListener('touchstart', function () {
                $vm.activeTooltip = !$vm.activeTooltip;
            })
        }
    }
</script>

<style scoped>

    label {
        float: left;
        font-size: 20px;
        color: #465978;
        width: 48% !important;
        margin-top: -7px;
        margin-bottom: 15px;
    }

    .btn {
        border: 1px solid rgb(206, 212, 218);
        font-size: 18px;
        padding: 1px 3px 3px 3px;
        color: #465978;
        width: 50%;
        white-space: normal;
    }

    .btn-group {
        width: 50%;
        margin-bottom: 16px;
        margin-left: auto;
        float: right;
    }

    .button-group-two {
        width: 85%;
        margin: 0 auto;
        overflow: hidden;
        clear: both;
    }

    .active-button {
        background-color: #465978;
        color: #fff;
    }

    .label-tooltip {
        background-color: #ee3124;
        width: 20px;
        border-radius: 50%;
        color: white;
        font-weight: bold;
        font-size: 16px;
        display: inline-block;
        font-family: 'Roboto', Arial, serif;
        position: relative;
        cursor: pointer;

        height: 0;
        padding: 10px 0%;
        line-height: 0;
        text-align: center;
    }

    .calc-tooltip {
        position: absolute;
        z-index: 9999;
        top: -60px;
        left: 0px;
        background-color: #465978;
        height: 58px;
        width: 250px;
        color: #fff;
        line-height: 16px;
        padding: 8px;
        opacity: 0.9;
        margin-left: -475%;
        white-space: normal;
    }

    .arrow-down {
        width: 0;
        height: 0;
        border-left: 10px solid transparent;
        border-right: 10px solid transparent;
        border-top: 10px solid black;
        margin-left: 88px;
        margin-bottom: 0;
        margin-top: 5px;
    }

    .deposit-source .calc-tooltip {
        width: 320px;
        height: 139px;
        top: -140px;
        margin-left: -475%;
    }

    .deposit-source .arrow-down {
        margin-left: 88px;
    }

    .loan-type-button-group .calc-tooltip {
        width: 320px;
        height: 106px;
        top: -107px;
        margin-left: -475%;
    }

    .loan-type-button-group .arrow-down {
        margin-left: 88px;
    }

    @media (min-width: 1024px) and (max-width: 1033px) {
        .loan-type-button-group .btn {
            font-size: 16px !important;
        }
    }

    @media (min-width: 1024px) {
        .loan-type-button-group .btn-group, .property-bought .btn-group {
            margin-bottom: 30px;
        }
    }

    @media (max-width: 767px) {
        label {
            margin-right: 0;
        }
        .btn {
            padding-bottom: 1px;
        }

        .calc-tooltip {
            margin-left: -145%;
        }

        .arrow-down {
            margin-left: 21px;
        }
    }

    @media (max-width: 435px) {
        .btn-group {
            width: 50%;
        }

        .btn {
            width: 50%;
        }
    }

    @media (max-width: 381px) {

        .arrow-down {
            margin-left: 51px;
        }
    }

    @media (max-width: 355px) {
        .btn {
            padding-left: 0;
            padding-right: 0;
        }
    }

    @media (max-width: 340px) {
        .deposit-source .calc-tooltip {
            width: 280px;
            height: 154px;
            top: -155px;
        }
    }

</style>


// WEBPACK FOOTER //
// src/Components/ButtonGroupTwo.vue